export const GRAPHIC_SETTINGS_SET_MARKER_SHADOWS = 'GRAPHIC_SETTINGS_SET_MARKER_SHADOWS';
export const GRAPHIC_SETTINGS_SET_SLIDE_ANIMATION_DURATION = 'GRAPHIC_SETTINGS_SET_SLIDE_ANIMATION_DURATION';
export const GRAPHIC_SETTINGS_SET_FORCED_CLUSTERING = 'GRAPHIC_SETTINGS_SET_FORCED_CLUSTERING';
export const GRAPHIC_SETTINGS_SET_ALLOW_IDLE_ANIMATIONS = 'GRAPHIC_SETTINGS_SET_ALLOW_IDLE_ANIMATIONS';
export const GRAPHIC_SETTINGS_RESET = 'GRAPHIC_SETTINGS_RESET';
